module.exports = __webpack_public_path__ + "static/media/it-extra-small.b4494e5a.svg";